import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, Meta, SafeResourceUrl, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { v4 as uuid } from 'uuid';
import { environment } from '../../../environments/environment';
import { Company, VacancyDetails } from '../../core/models';
import { CompaniesService } from '../../core/services/companies.service';
import { VacancyService } from '../../core/services/vacancy.service';
import { ModalValidationEmployeeComponent } from './modal-validation-employee/modal-validation-employee.component';

declare var branch;
declare var ga;
declare var fbq;

@Component({
  selector: 'app-companies-details',
  templateUrl: './companies-details.component.html',
  styleUrls: ['./companies-details.component.scss']
})

export class CompaniesDetailsComponent implements OnInit, AfterViewInit {

  @ViewChild('vancancyEl', { static: true }) vancancyEl: ElementRef;
  @ViewChild('about') aboutPosition: ElementRef;
  @ViewChild('mission') missionPosition: ElementRef;
  @ViewChild('process', { static: true }) processPosition: ElementRef;

  url_pwa: string;
  hiddenPage: boolean = false as boolean;
  gallery: any = [];
  company: Company;
  vacancies: any[];
  highlightVacancies: any[] = [];
  banner: string;
  pagination: any = {
    skip: 0,
    limit: 0,
    total: 0
  };
  load: Boolean = false;
  error: Boolean = false;
  mobile: boolean;
  errorMessage: string;
  loadVacancies: Boolean = false;
  skipPagination: any = 9;
  type: string = environment.type.toUpperCase();
  showPhotoGallery = false;
  scrollPositions: any;
  pagLog: any = {
    pagination: {
      skip: 0,
      limit: 9
    }
  };
  sharedUrl: any;
  public isPJOpportunity: boolean = false as boolean;

  sendLink: Boolean = false;
  cellphoneNumber: Number;
  queryParams: any = {};
  safeURL: SafeResourceUrl;
  vacancy: VacancyDetails;
  smsStatus: {
    sending?: boolean,
    success?: boolean,
    failure?: boolean;
  } = {};

  cellphoneMask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    margin: 10,
    autoWidth: true,
    center: false,
    navSpeed: 700,
    navText: ['<img src="assets/images/icons/chevrons-left.svg">', '<img src="assets/images/icons/chevrons-right.svg">'],
    items: 1,
    nav: true
  };

  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
  }

  constructor(
    @Inject(PLATFORM_ID)
    private platformId: Object,
    private route: ActivatedRoute,
    private router: Router,
    private companyService: CompaniesService,
    private vacancyService: VacancyService,
    private _sanitizer: DomSanitizer,
    private deviceService: DeviceDetectorService,
    private dialog: MatDialog,
    private titleService: Title,
    private metaService: Meta
  ) {
    // branch.init(environment.branch_key);
    this.mobile = this.deviceService.isMobile();
  }

  ngOnInit() {
    if (this.router.url.indexOf('/preview') >= 0) {
      this.getCompanyPreview();
    } else {
      this.getCompany();
    }

    this.scrollPositions = [
      { key: 'vacancy', scroll: this.vancancyEl },
      { key: 'about', scroll: this.aboutPosition },
      { key: 'mission', scroll: this.missionPosition },
      { key: 'process', scroll: this.processPosition }
    ];

    if (isPlatformBrowser(this.platformId)) {
      branch.init(environment.branch_key);
    }

    this.url_pwa = environment.url_pwa;
  }

  ngAfterViewInit() {
    this.scrollPositions = [
      { key: 'vacancy', scroll: this.vancancyEl },
      { key: 'about', scroll: this.aboutPosition },
      { key: 'mission', scroll: this.missionPosition },
      { key: 'process', scroll: this.processPosition }
    ];
  }

  async getCompanyPreview() {

    const companyKey = this.route.snapshot.params.companyKey;
    this.load = true;
    await this.companyService.getCompanyPreviewByKey(companyKey).subscribe(res => {
      this.company = res;

      this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(this.company.landingPage.video);
      if (this.company.landingPage.config.showPhotoGallery === true) {
        this.showPhotoGallery = !!(this.company.landingPage && this.company.landingPage.photoGallery && this.company.landingPage.photoGallery.length);
        this.getGallery();
      }
      if (this.company.landingPage.config.showVacancies === true) {
        this.getVacanciesHighlight();
        this.getVacancies();
      }
      this.setOpportunity();
      this.load = false;
      this.error = false;
    }, (error) => {
      this.error = true;
      this.errorMessage = error.error.details;
    });
  }

  async getCompany() {

    const companyKey = this.route.snapshot.params.companyKey;
    this.load = true;

    await this.companyService.getCompanyByKey(companyKey).subscribe(res => {

      if (isPlatformServer(this.platformId)) {
        this.setDynamicHeader(res);
      }

      this.company = res;
      this.banner = this.company.coover;

      if (this.router.url.indexOf('/interno') >= 0) {
        this.openDialog();
        this.company.landingPage.config.showVacancies = false;
      }

      this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(this.company.landingPage.video);
      if (this.company.landingPage.config.showPhotoGallery === true) {
        this.showPhotoGallery = !!(this.company.landingPage && this.company.landingPage.photoGallery && this.company.landingPage.photoGallery.length);
        this.getGallery();
      }
      if (this.company.landingPage.config.showVacancies === true) {
        this.getVacanciesHighlight();
        this.getVacancies();
      }

      this.setOpportunity();
      this.load = false;
      this.error = false;
    }, (error) => {
      this.error = true;
      this.errorMessage = error.error.details;
    });
  }

  setOpportunity() {
    const pjCompanies = ['61152289ed00c6004771872c'];
    this.isPJOpportunity = this.company._id && pjCompanies.includes(String(this.company._id));
  }

  hexToRGB(hex, alpha) {
    if (hex) {
      const r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

      if (alpha) {
        return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
      } else {
        return 'rgb(' + r + ', ' + g + ', ' + b + ')';
      }
    }
  }

  async getGallery() {
    if (!this.company.landingPage.photoGallery) return;
    for (const index of this.company.landingPage.photoGallery) {
      this.gallery.push({
        id: uuid(),
        alt: 'carouselImage',
        src: index,
      });
    }
  }

  async getVacanciesHighlight() {
    this.loadVacancies = true;

    const params = {
      pagination: this.pagLog.pagination,
      filters: { highlight: true },
      company: this.company._id,
    };

    if (this.hiddenPage) {
      await this.vacancyService.getPrivateVacancies(this.company.key, params)
        .subscribe(res => {
          this.highlightVacancies = res.data;
          this.loadVacancies = false;
          this.error = false;
        }, (error) => {
          this.error = true;
          this.errorMessage = error.error.details;
        });
    } else {
      await this.vacancyService.getVacanciesByCompany(this.company.key, params)
        .subscribe(res => {
          this.highlightVacancies = res.data;
          this.loadVacancies = false;
          this.error = false;
        }, (error) => {
          this.error = true;
          this.errorMessage = error.error.details;
        });
    }
  }

  async getVacancies() {
    this.loadVacancies = true;

    this.pagLog.company = this.company._id;

    if (this.hiddenPage) {
      await this.vacancyService.getPrivateVacancies(this.company.key, this.pagLog)
        .subscribe(res => {
          this.vacancies = res.data;
          this.pagination = res.pagination;
          this.loadVacancies = false;
          this.error = false;
        }, (error) => {
          this.error = true;
          this.errorMessage = error.error.details;
        });
    } else {
      await this.vacancyService.getVacanciesByCompany(this.company.key, this.pagLog)
        .subscribe(res => {
          this.vacancies = res.data;
          this.pagination = { ...this.pagination, ...res.pagination };
          this.loadVacancies = false;
          this.error = false;
        }, (error) => {
          this.error = true;
          this.errorMessage = error.error.details;
        });
    }
  }

  async goNext() {
    this.pagLog.pagination.skip = this.pagLog.pagination.skip + this.pagLog.pagination.limit;
    this.skipPagination += this.pagLog.pagination.limit;
    await this.getVacancies();
    window.scroll({
      top: 0,
      behavior: 'smooth'
    });
  }

  async goPrevious() {
    this.pagLog.pagination.skip = this.pagLog.pagination.skip - this.pagLog.pagination.limit;
    this.skipPagination -= this.pagLog.pagination.limit;
    await this.getVacancies();
    window.scroll({
      top: 0,
      behavior: 'smooth'
    });
  }

  async sendSMS() {
    const options = {},
      linkData = {
        feature: 'TextMeTheApp',
        data: {
          // tslint:disable-next-line:max-line-length
          utm_campaign: this.company.key,
          utm_medium: this.queryParams.utm_medium || 'organic',
          utm_source: this.queryParams.utm_source,
          utm_term: this.queryParams.utm_term,
          utm_content: this.queryParams.utm_content,
          company_id: this.company._id,
          user_referral: this.queryParams.user_referral
        }
      };

    this.smsStatus = {
      sending: true
    };

    const phoneNumber = this.cellphoneNumber.toString().replace(/[()-\s]/g, '');
    branch.sendSMS('+55' + phoneNumber, linkData, options, (err) => {
      this.smsStatus.sending = false;
      this.smsStatus.failure = !!err;
      this.smsStatus.success = !err;

      if (this.smsStatus.success && ga) {
        ga('send', {
          hitType: 'event',
          eventCategory: 'Download',
          eventAction: 'Enviou link via SMS',
        });
      }

      if (this.smsStatus.success && fbq) {
        fbq('trackCustom', 'Download', {
          content_category: 'Landing Page',
          content_name: 'Enviou link via SMS'
        });
      }
      this.sendLink = true;
    });
  }

  goToDeeplink(canRetry = true) {
    branch.link({
      data: {
        utm_campaign: this.queryParams.utm_campaign !== undefined ? this.queryParams.utm_campaign : this.company.key,
        utm_medium: this.queryParams.utm_medium || 'organic',
        utm_source: this.queryParams.utm_source,
        utm_term: this.queryParams.utm_term,
        utm_content: this.queryParams.utm_content,
        company_id: this.company._id,
        user_referral: this.queryParams.user_referral,
        way: this.queryParams.way,
      }
    }, (err, link) => {

      if (link && !err) {
        if (ga) {
          ga('send', {
            hitType: 'event',
            eventCategory: 'Download',
            eventAction: 'clicou',
          });
        }

        if (fbq) {
          fbq('trackCustom', 'Download', {
            content_category: 'Landing Page',
            content_name: 'clicou'
          });
        }

        window.location.href = link;
        return;
      }

      if (err && canRetry) {
        this.goToDeeplink(false);

      } else if (err && !canRetry) {
        window.location.href = environment.link_branch;
      }
    });
  }

  clickOnApplyButton() {
    try {
      ga('send', {
        hitType: 'event',
        eventCategory: 'Outbound Link',
        eventAction: 'click',
        eventLabel: 'enviar', // event.target
        eventValue: 0
      });
    } catch (err) {}

    if (!this.mobile) {
      let params = ``;

      const utm_campaign = this.queryParams.utm_campaign !== undefined ? this.queryParams.utm_campaign : this.company.key;
      const utm_medium = this.queryParams.utm_medium || 'organic';
      const utm_source = this.queryParams.utm_source;
      const utm_term = this.queryParams.utm_term;
      const utm_content = this.queryParams.utm_content;
      const company_id = this.company._id;
      const user_referral = this.queryParams.user_referral;
      const way = this.queryParams.way;

      if (utm_campaign) {
        params += `?utm_campaign=${utm_campaign}`;
      }

      if (utm_medium) {
        params += `&utm_medium=${utm_medium}`;
      }

      if (utm_source) {
        params += `&utm_source=${utm_source}`;
      }

      if (utm_term) {
        params += `&utm_term=${utm_term}`;
      }

      if (utm_content) {
        params += `&utm_content=${utm_content}`;
      }

      if (company_id) {
        params += `&company_id=${company_id}`;
      }

      if (user_referral) {
        params += `&user_referral=${user_referral}`;
      }

      if (way) {
        params += `&way=${way}`;
      }

      // tslint:disable-next-line: max-line-length
      if (this.company && this.company.key && environment.whiteLabel[this.company.key] && environment.whiteLabel[this.company.key].url_pwa) {
        this.url_pwa = environment.whiteLabel[this.company.key].url_pwa;
      }

      window.open(`${this.url_pwa}/#!/taqe/tabs/vacancies${params}`, '_blank');
      return;
    }

    this.goToDeeplink();
  }

  openDialog(): void {
    const dialog = this.dialog.open(ModalValidationEmployeeComponent, {
      width: '400px',
      data: {
        company: this.company,
        sharedUrl: this.sharedUrl || undefined,
        url_path: this.route.snapshot.url[0].path
      }
    });
    dialog.afterClosed().subscribe((res) => {
      if (res.validate) {
        this.company.landingPage.config.showVacancies = true;
        this.getVacancies();
      }
    });
  }

  setDynamicHeader(company) {
    const currentProject = environment.type === 'ciee' ? 'CIEE One' : 'TAQE';
    const title = `Vagas na organização ${company.fantasyName}: Candidate-se agora | ${currentProject}`;
    const description = `Encontre a oportunidade na organização ${company.fantasyName} certa para o seu perfil de candidato. Acesse e conheça as oportunidades de emprego aberta e candidate-se agora!`;

    this.titleService.setTitle(title);
    this.metaService.updateTag({ property: 'og:title', content: title });
    this.metaService.updateTag({ property: 'og:description', content: description });
    this.metaService.updateTag({ property: 'og:image', content: company.logo });
  }

  configText(text = ''): string {
    let validateText = typeof text == 'string' ? text : '';
    return validateText.replace(/\n/g, '<br />');
  }
}
